<template>
    <div>
        <el-form :inline="true" :model="systemOrderForm">
            <el-form-item label="下载类型：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>导入</el-option>
                    <el-option>下载</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下载时间：">
                <el-date-picker v-model="systemOrderForm.date" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号"></el-table-column>      
            <el-table-column prop="3" label="业务类型"></el-table-column>
            <el-table-column prop="3" label="下载类型"></el-table-column>
            <el-table-column prop="4" label="状态"></el-table-column>
            <el-table-column prop="5" label="开始时间"></el-table-column>
            <el-table-column prop="6" label="结束时间"></el-table-column>
            <el-table-column prop="6" label="操作人"></el-table-column>
            <el-table-column prop="6" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small">删除</el-button>
                </template> 
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>        
    </div>
</template>
<script>
export default {
    data(){
        return {
            systemOrderForm: {
                date: '',
                agentName: ''
            },
            tableData: [
                {
                    2: '123123',
                    3: 'aaaaaaa',
                    4: 'ooooooo'
                },
                {
                    2: 'q123123',
                    3: 'qaaaaaaa',
                    4: 'qooooooo'
                }
            ],
            multipleSelection: []
        }
    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
        }
    }
}
</script>
<style lang="less" scoped>

</style>

